import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import { FaPlusCircle, FaTrash, FaWhatsapp } from 'react-icons/fa';
import { Line, Doughnut } from 'react-chartjs-2';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './calender.css'
import loadingfee from '../assets/images/fee-loading.gif'
import student from '../assets/images/std.png'
import fee from '../assets/images/fee.png'
import teacher from '../assets/images/teacher.png'
import teachersmultiple from '../assets/images/teachersmultiple.jpg'
import { motion } from 'framer-motion';
import AlertMessage from '../AlertMessage';



import malefemale from '../assets/images/malefemale.png'

const SchoolDataCard = () => {

  const [totalStudents, setTotalStudents] = useState(0);
  const [loading, setLoading] = useState(true); 
  const [totalTeachers, setTotalTeachers] = useState(0); 
  const [todayfee, setTodayFee] = useState(0); 
  const [serialNumbers, setSerialNumbers] = useState([]);
  const presentTeachers = 0;
  const [maleFemaleRatio, setMaleFemaleRatio] = useState([0, 0]); // Initialize with zero counts
  const [events, setEvents] = useState([]); 
  const [showForm, setShowForm] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [message, setMessage] = useState(''); 
  const [title, setTitle] = useState('');
  const [noticeFilter, setNoticeFilter] = useState('all');
  const [noticeTarget, setNoticeTarget] = useState('teacher');
  const [studentData, setStudentData] = useState([]);
  const [currentDefaultYear, setcurrentDefaultYear] = useState('');
  const [classes, setClasses] = useState([]);
  const [notices, setNotices] = useState([]);
  const [selectedNotices, setSelectedNotices] = useState([]);
  const [maleCount, setMaleCount] = useState(0);
  const [femaleCount, setFemaleCount] = useState(0);
  const udiseNumber = localStorage.getItem('udiseNumber'); // Ensure this key exists in local storage
  const language = localStorage.getItem('language'); // Ensure this key exists in local storage
  const invoiceNo = localStorage.getItem('invoiceNo');
  
  const userStatus = localStorage.getItem('userStatus');
  const role = localStorage.getItem('role');
  const isAdmin = userStatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || role === "admin";
  
const [alertMessage, setAlertMessage] = useState("");
const [showAlert, setShowAlert] = useState(false);
useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); 
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const formattedDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed) and pad
    const year = date.getFullYear(); // Get full year
    return `${day}-${month}-${year}`; // Return formatted date
  };
  const fetchDefaultYear = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['defaultSettings'], 'readonly');
      const objectStore = transaction.objectStore('defaultSettings');
      const request = objectStore.get('defaultSettings');
  
      request.onsuccess = async (event) => {
        const defaultSetting = event.target.result;
        
        if (defaultSetting) {
          const currentDefaultYear = defaultSetting.defaultYear;
          
          setcurrentDefaultYear(currentDefaultYear);
          await  fetchStudentCount(currentDefaultYear);
          await countTeachers();
          await  fetchSchoolData ();
          await fetchStudentData(currentDefaultYear);
          await  fetchNotices();
        } else {
          console.warn("No default settings found for the key 'defaultSettings'.");
        }
      };
  
      
      request.onerror = (event) => {
        console.error("Error fetching default settings:", event.target.error);
      };
    } catch (error) {
      console.error('Error fetching default year:', error);
    }
  };

  const fetchNotices = async () => {
    try {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/notices.json`;
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      
      let allNotices = [];
      if (data && typeof data === 'object') {
        const processNode = (nodeData, nodeName) => {
          if (nodeData && typeof nodeData === 'object') {
            Object.entries(nodeData).forEach(([key, value]) => {
               if (value && typeof value === 'object') {
                  allNotices.push({
                     id: key,
                     subNode: nodeName,
                     title: value.title || "",
                     message: value.message || "",
                     type: value.type || nodeName,
                     createdBy: value.createdBy || "",
                     createdByName: value.createdByName || "",
                     createdAt: value.createdAt || Date.now(),
                     date: value.createdAt ? new Date(value.createdAt).toISOString().split('T')[0] : (Object.keys(value).length > 0 ? Object.keys(value)[0] : "")
                  });
               }
            });
          }
        };

        if (data.teacher) processNode(data.teacher, 'teacher');
        if (data.student) processNode(data.student, 'student');
        if (data.combine) processNode(data.combine, 'combine');

        Object.entries(data).forEach(([key, value]) => {
          if (key !== 'teacher' && key !== 'student' && key !== 'combine') {
            if (value.title !== undefined || value.createdAt !== undefined) {
               allNotices.push({
                   id: key,
                   subNode: '',
                   title: value.title || "",
                   message: value.message || "",
                   type: value.type || "teacher",
                   createdBy: value.createdBy || "",
                   createdByName: value.createdByName || "",
                   createdAt: value.createdAt || Date.now(),
                   date: value.createdAt ? new Date(value.createdAt).toISOString().split('T')[0] : (Object.keys(value).length > 0 ? Object.keys(value)[0] : "")
               });
            } else {
               Object.entries(value).forEach(([date, message]) => {
                 if (typeof message === 'string') {
                    allNotices.push({ id: key, subNode: '', date, message, type: "teacher", title: "" });
                 }
               });
            }
          }
        });
      }
  
      setNotices(allNotices); 
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };

  const deleteNotice = async (idOrDate, subNode) => {
    try {
      let noticeIdToDelete = idOrDate;
      // If we don't have a specific subNode, check the top level
      if (!subNode) {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/notices.json`;
        const response = await fetch(url);
        if (response.ok) {
           const noticesData = await response.json();
           if (noticesData && !noticesData[idOrDate]) {
             for (const [id, notice] of Object.entries(noticesData)) {
               if (notice && notice.hasOwnProperty(idOrDate)) {
                 noticeIdToDelete = id;
                 break;
               }
             }
           }
        }
      }
  
      const deletePath = subNode ? `notices/${subNode}/${noticeIdToDelete}` : `notices/${noticeIdToDelete}`;
      const deleteUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/${deletePath}.json`;
      const deleteResponse = await fetch(deleteUrl, { method: 'DELETE' });
      if (!deleteResponse.ok) throw new Error('Failed to delete notice');
  
      setAlertMessage('Notice deleted successfully');
      fetchNotices(); 
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  const saveNotice = async (date, message, title, targetSubNode) => {
    try {
      const userName = localStorage.getItem('userName') || "";
      const userId = localStorage.getItem('userId') || ""; 
      const subNode = targetSubNode || "teacher";

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/notices/${subNode}.json`;
      const noticeData = {
        title: title || "",
        message: message || "",
        type: subNode,
        createdBy: userId,
        createdByName: userName,
        createdAt: new Date(date).getTime()
      };
  
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(noticeData),
      });
  
      if (!response.ok) throw new Error('Failed to save notice');
      fetchNotices();
    } catch (error) {
      console.error('Error saving notice:', error);
    }
  };

  const renderTileContent = ({ date, view }) => {
    // Convert date to YYYY-MM-DD format in UTC
    const formattedDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split('T')[0];
    
    const event = notices.find((notice) => {
      return notice.date === formattedDate; // Compare the date key with the formatted date
    });
  
    if (event) {
      return (
        <span 
          style={{ color: '#ff6384', position: 'relative' }} 
        >
          •
        </span>
      );
    }
  };

  const countTeachers = async () => {      
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
    const response = await fetch(url);
    
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    
    const data = await response.json();
    let teacherCount = 0; // Initialize teacherCount to 0

    if (data && typeof data === 'object' && Object.keys(data).length > 0) {
      const employees = Object.values(data);
      
      employees.forEach((employeeSnapshot) => {
          const currentTeacher = employeeSnapshot?.Currentteacher; // Use optional chaining
          if (currentTeacher && currentTeacher.Jobrole === "Teacher") {
              teacherCount++;
          }
      });
    } else {
      console.warn("No employee data found or data is not an object.");
    }
    setTotalTeachers(teacherCount); // Update the state with the count
}
 


  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedDate && message) {
      saveNotice(selectedDate.toISOString().split('T')[0], message, title, noticeTarget);
      const newEvent = { date: selectedDate, message, title };
      setEvents([...events, newEvent]);
      setShowForm(false); // Close the form
      setMessage(''); // Clear the message input
      setTitle(''); // Clear the title input
    }
  };
 
  

  
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  const fetchStudentData = async (currentDefaultYear) => {
    try {
   const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const data = event.target.result;
  
      // Filter out null entries
      const filteredData = Object.keys(data)
        .filter(key => data[key] !== null)
        .map(key => ({ srNo: key, ...data[key] }));
  console.log("currentDefaultYear",currentDefaultYear);
  
      setStudentData(filteredData);
  if(currentDefaultYear){
    console.log("a");
    
    const studentsForDefaultYear = filteredData.filter(
      student => student.educationalYear === currentDefaultYear
    );

    // Count genders for students with the current default year
    const maleCount = studentsForDefaultYear.filter(
      student => student.gender && student.gender.trim().toLowerCase() === 'male'
    ).length;

    const femaleCount = studentsForDefaultYear.filter(
      student => student.gender && student.gender.trim().toLowerCase() === 'female'
    ).length;


    // Update the gender data for the chart
    setMaleFemaleRatio([maleCount, femaleCount]);
    setMaleCount(maleCount); // Set male count
    setFemaleCount(femaleCount); // Set female count

    const classSet = new Set();
    studentsForDefaultYear.forEach((student) => {
      if (student.currentClass) {
        classSet.add(String(student.currentClass));
      }
    });
    setClasses([...classSet]);
  }else{
    console.log("e");
    
    const studentsForDefaultYear = filteredData;

    // Count genders for students with the current default year
    const maleCount = studentsForDefaultYear.filter(
      student => student.gender && student.gender.trim().toLowerCase() === 'male'
    ).length;

    const femaleCount = studentsForDefaultYear.filter(
      student => student.gender && student.gender.trim().toLowerCase() === 'female'
    ).length;


    // Update the gender data for the chart
    setMaleFemaleRatio([maleCount, femaleCount]);
    setMaleCount(maleCount); // Set male count
    setFemaleCount(femaleCount); // Set female count
    const classSet = new Set();
    studentsForDefaultYear.forEach((student) => {
      if (student.currentClass) {
        classSet.add(String(student.currentClass));
      }
    });
    setClasses([...classSet]);
  }
    
  
      // Extract unique classes for students with the current default year
     
    };

    allRecords.onerror = (event) => {
      console.error('Error fetching student data from IndexedDB:', event.target.error);
    };
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };
  const classOrder = {
    'Class I': 1,
    'Class II': 2,
    'Class III': 3,
    'Class IV': 4,
    'Class V': 5,
    'Class VI': 6,
    'Class VII': 7,
    'Class VIII': 8,
    'Class IX': 9,
    'Class X': 10,
    'Class XI': 11,
    'Class XII': 12,
    'इयत्ता पहिली': 1,
    'इयत्ता दुसरी': 2,
    'इयत्ता तिसरी': 3,
    'इयत्ता चौथी': 4,
    'इयत्ता पाचवी': 5,
    'इयत्ता सहावी': 6,
    'इयत्ता सातवी': 7,
    'इयत्ता आठवी': 8,
    'इयत्ता नववी': 9,
    'इयत्ता दहावी': 10,
    'इयत्ता अकरावी': 11,
    'इयत्ता बारावी': 12,
  };
  const sortedClasses = classes.sort((a, b) => {
    return classOrder[a] - classOrder[b];
  });
  const classData = {
    labels: sortedClasses,
    datasets: [
      {
        label: language === "English" ? "Total Students in Class" : "वर्गातील एकूण विद्यार्थी",
        data: classes.map((classItem) => {
          if(currentDefaultYear){
            return studentData.filter(
              (student) => student.currentClass === classItem && student.educationalYear === currentDefaultYear
            ).length;
          }else{
            return studentData.filter(
              (student) => student.currentClass === classItem
            ).length;
          }
          
        }),
        borderColor: '#36a2eb',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        fill: true,
        borderWidth: 2,
        tension: 0.4,
      },
    ],
  };


  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: 'easeInOutQuart',
    },
  };
  const handleDateChange = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    setSelectedDate(utcDate);
    
    const formattedDate = utcDate.toISOString().split('T')[0];
    
    // Find all notices for the selected date
    const eventsForDate = notices.filter((notice) => notice.date === formattedDate);
    setSelectedNotices(eventsForDate); // Set the selected notices
  };

const fetchStudentCount = async (currentDefaultYear) => {
  try {
  
    const db = await openIndexedDB();
    const transaction = db.transaction(['studentData'], 'readonly');
    const objectStore = transaction.objectStore('studentData');
    const allRecords = objectStore.getAll();

    allRecords.onsuccess = (event) => {
      const studentData = event.target.result;
    if (!studentData) {
      setTotalStudents(0); // Set total students to 0 if no data is found
      setLoading(false); // Stop loading after data is fetched
      return; 
    }

    let count = 0;
    Object.keys(studentData).forEach((key) => {
      const student = studentData[key];
if(currentDefaultYear){
  if (student && student.educationalYear === currentDefaultYear) {
    count += 1;
  } 
}else{
  count = studentData.length;
}
     
    });
    setTotalStudents(count);
  };

  allRecords.onerror = (event) => {
    console.error('Error fetching student data from IndexedDB:', event.target.error);
  };
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false); 
  }
};


const [feeLoading, setFeeLoading] = useState(false); 
  
const fetchTodayFeeDifference = async () => {
  setFeeLoading(true);   
  try {
    const currentDate = new Date().toISOString().split('T')[0];
    let totalDifference = 0;

    for (const serialNo of serialNumbers) {
      const invoiceDataUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${serialNo}.json`;
      const invoiceResponse = await fetch(invoiceDataUrl);
      if (!invoiceResponse.ok) {
        throw new Error('Network response was not ok');
      }
      const invoiceData = await invoiceResponse.json();

      const invoiceNumbers = Object.keys(invoiceData);
      if (invoiceNumbers.length === 0) continue;

      const lastInvoiceNo = Math.max(...invoiceNumbers.map(Number));
      const lastInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${serialNo}/${lastInvoiceNo}.json`;
      const lastInvoiceResponse = await fetch(lastInvoiceUrl);
      if (!lastInvoiceResponse.ok) {
        throw new Error('Network response was not ok');
      }
      const lastInvoiceData = await lastInvoiceResponse.json();

      const lastInvoiceDate = Object.keys(lastInvoiceData).find(key => lastInvoiceData[key].date === currentDate);
      if (lastInvoiceDate) {
        const lastBeforePay = parseFloat(lastInvoiceData[lastInvoiceDate].beforePay) || 0;

        if (invoiceNumbers.length === 1) {
          totalDifference += lastBeforePay;
        } else {
          const previousInvoiceNo = Math.max(...invoiceNumbers.filter(num => num < lastInvoiceNo).map(Number));
          const previousInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${serialNo}/${previousInvoiceNo}.json`;
          const previousInvoiceResponse = await fetch(previousInvoiceUrl);
          if (!previousInvoiceResponse.ok) {
            throw new Error('Network response was not ok');
          }
          const previousInvoiceData = await previousInvoiceResponse.json();

          const previousBeforePay = previousInvoiceData && previousInvoiceData[lastInvoiceDate]
            ? parseFloat(previousInvoiceData[lastInvoiceDate].beforePay) || 0
            : 0;

          const difference = lastBeforePay - previousBeforePay;
          totalDifference += difference;
        }
      }
    }

    setTodayFee(totalDifference);
  } catch (error) {
    console.error('Error fetching today fee difference:', error);
  } finally {
    setFeeLoading(false); 
  }
};

useEffect(() => {
  if (currentDefaultYear) {
    fetchTodayFee();
    fetchSerialNumbers();
  }
}, [currentDefaultYear]);


useEffect(()=>{
  fetchDefaultYear();
}, [udiseNumber])


const fetchSerialNumbers = async () => {
  try {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee.json`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    
    // Extract serial numbers from the fetched data
    const serials = Object.keys(data);
    setSerialNumbers(serials); // Set the state with the serial numbers
  } catch (error) {
    console.error('Error fetching serial numbers:', error);
  }
};

// Function to fetch to?day's fee from Firebase for multiple serial numbers and their invoice numbers
const fetchTodayFee = async () => {
  try {
    const fees = []; // Array to hold fetched fees
    const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format

    for (const serialNo of serialNumbers) {
      // Fetch the invoice numbers for the current serial number
      const invoiceDataUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${serialNo}.json`;
      const invoiceResponse = await fetch(invoiceDataUrl);
      if (!invoiceResponse.ok) {
        throw new Error('Network response was not ok');
      }
      const invoiceData = await invoiceResponse.json();

      // Check if the invoice data is not null
      if (invoiceData) {
        // Get the invoice numbers from the studentFee object
        const invoiceNumbers = Object.keys(invoiceData.studentFee);
        const lastInvoiceNo = Math.max(...invoiceNumbers.map(Number)); 
        const lastInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${serialNo}/studentFee/${lastInvoiceNo}.json`;
        const lastInvoiceResponse = await fetch(lastInvoiceUrl);
        if (!lastInvoiceResponse.ok) {
          throw new Error('Network response was not ok');
        }
        const lastInvoiceData = await lastInvoiceResponse.json();

        // Check if the date of the last invoice matches the current date
        if (lastInvoiceData && lastInvoiceData.date === currentDate) {
          if (lastInvoiceData.beforePay) {
           
            fees.push(lastInvoiceData.beforePay); // Add the fetched value to the array
          } else {
            console.error(`No beforePay found for Serial No: ${serialNo}, Last Invoice No: ${lastInvoiceNo}`);
          }
        }
      }
    }

    // Calculate the total today's paid fee
    const totalTodayFee = fees.reduce((acc, fee) => acc + parseFloat(fee || 0), 0);
    setTodayFee(totalTodayFee); // Set the state with the total today's paid fee
  } catch (error) {
    console.error('Error fetching today fee:', error);
  }
};


useEffect(() => {
  if (serialNumbers.length > 0) {
    fetchTodayFeeDifference(); // Call fetchTodayFeeDifference when serialNumbers are set
  }
}, [serialNumbers]); // Dependency on serialNumbers


const [schoolData, setSchoolData] = useState(null);
  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };





  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }} // Start slightly transparent and moved down
      animate={{ opacity: 1, y: 0 }} // Fade in and move up
      transition={{ duration: 0.5 }} // Animation duration
    >
   <AlertMessage message={alertMessage} show={showAlert}/>
    <Container fluid className="p-4">
      <Row className="mb-5">
        <Col md={3}>
        <Card className="text-center" style={{MinWidth:'300px'}}>
  <Card.Body>
   
    {loading ? (
      <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
    ) : (
      <div className="d-flex justify-content-center" >
       
        <div style={{ paddingRight:'10px' }}>
          <div className="text-center">
            <img 
              src={student} 
              alt="Total Students" 
              style={{ width: '70px', height: '60px' }} 
            />
            <h6 style={{color:'#e80d34'}} >{language==="English"?"Total Students":"एकूण विद्यार्थी"} </h6> 
          </div>
        </div>

        <div style={{ marginTop:'1%', borderLeft:'1px solid gray' , paddingLeft:'10px'}}>
          <h2 style={{    color:'#0e7bf1' , marginTop:'25px'}}>{totalStudents || '0'}</h2>
        </div>
      </div>
    )}
  </Card.Body>
</Card>


        </Col>
        <Col md={3}>
        <Card className="text-center" style={{MinWidth:'300px'}}>
  <Card.Body>
   
    {loading ? (
      <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
    ) : (
      <div className="d-flex justify-content-center" >
       
        <div style={{ paddingRight:'10px' }}>
          <div className="text-center">
            <img 
              src={teachersmultiple} 
              alt="Total Teachers" 
              style={{ width: '75px', height: '60px' }} 
            />
            <h6 style={{color:'#e80d34'}} >{language==="English"?"Total Teachers":"एकूण शिक्षक"}</h6> 
          </div>
        </div>

        <div style={{ marginTop:'1%', borderLeft:'1px solid gray' , paddingLeft:'10px'}}>
          <h2 style={{    color:'#0e7bf1' , marginTop:'25px'}}>{totalTeachers || '0'}</h2>
        </div>
      </div>
    )}
  </Card.Body>
</Card>


          
        </Col>
        <Col md={3}>


        <Card className="text-center" style={{MinWidth:'300px'}}>
  <Card.Body>
   
    {loading ? (
      <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
    ) : (
      <div className="d-flex justify-content-center" >
       
        <div style={{ paddingRight:'10px' }}>
          <div className="text-center">
            <img 
              src={fee} 
              alt="Students Fee" 
              style={{ width: '70px', height: '60px' }} 
            />
            <h6 style={{color:'#e80d34'}} >{language==="English"?" Fee Paid":" भरलेले शुल्क"}</h6> 
          </div>
        </div>

        <div style={{ marginTop:'1%', borderLeft:'1px solid gray' , paddingLeft:'10px'  }}>
          <h2 style={{color:'#0e7bf1' , marginTop:'25px'}}>{loading || feeLoading ? ( 
        <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
      ) : (
        <>
        {todayfee}
        </>
      )}</h2>
        </div>
      </div>
    )}
  </Card.Body>
</Card>


        
        </Col>
        <Col md={3}>

        <Card className="text-center" style={{MinWidth:'300px'}}>
  <Card.Body>
   
    {loading ? (
      <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
    ) : (
      <div className="d-flex justify-content-center" >
       
        <div style={{ paddingRight:'6px' }}>
          <div className="text-center">
            <img 
              src={teacher} 
              alt="Present Teachers" 
              style={{ width: '70px', height: '60px' }} 
            />
            <h6 style={{color:'#e80d34'}} >{language==="English"?"Present Teachers":" उपस्थित शिक्षक"}</h6> 
          </div>
        </div>

        <div style={{ marginTop:'1%', borderLeft:'1px solid gray' , paddingLeft:'10px'}}>
          <h2 style={{color:'#0e7bf1' , marginTop:'25px'}}>{presentTeachers}</h2>
        </div>
      </div>
    )}
  </Card.Body>
</Card>

        </Col>
      </Row>

      <Row className="mb-5">
      <style jsx>{`
      .wave {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.wave::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #36a2eb;
  transform: translateX(-100%);
  animation: wave 2s infinite;
}

@keyframes wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
      `}</style>
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title><b style={{color:'#03365e'}} >{language==="English"?"Students By Class ":"वर्गानुसार विद्यार्थी"}</b></Card.Title>
              <div style={{ position: 'relative', height: '250px' }}>
              {loading ? (
      <div className="text-center">
          <img style={{ height:'25px'}} src={loadingfee} alt="Loading..." />
        </div>
    ) : (
      <Line data={classData} options={chartOptions} />
    )}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
  <Card>
  <Card>
  <Card.Body>
    <Card.Title><b style={{color:'#03365e'}} >{language==="English"?"Boy-Girl Ratio ":"मुलगा-मुलगी गुणोत्तर"}</b></Card.Title>
    <div style={{ position: 'relative', height: '250px' }}>
      
      <Doughnut 
        data={{
          labels: [ language === "English" ? "Male" : "मुलगा", language === "English" ? "Female" : "मुलगी ",], 
          datasets: [
            {
              data: [maleCount, femaleCount], // Use the counts directly
              backgroundColor: ['#36a2eb', '#ff6384'],
              hoverOffset: 4,
            },
          ],
        }} 
        options={chartOptions} 
      />
      
      {/* Image centered inside Doughnut */}
      <img 
        src={malefemale} 
        alt="Center Image" 
        style={{
          position: 'absolute', 
          top: '55%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', // This centers the image
          width: '70px', // You can adjust the size
          height: '70px', // You can adjust the size
        }} 
      />
    </div>
  </Card.Body>
</Card>

  </Card>
</Col>
      </Row>

      <Row className='mb-3'>
  <Col md={12}>
    <Card>
      <Card.Body>
       
        <Row>
          <Col md={5}>
          <div style={{ marginTop: '10px' }}>
              <Card.Title style={{ marginBottom: '20px' }}><b style={{color:'#03365e'}} >{language==="English"?"Calendar":"कॅलेंडर"}</b></Card.Title>
              <Calendar
          className="react-calendar"
          onChange={handleDateChange}
          value={selectedDate}
          tileContent={renderTileContent}
          formatMonthYear={(locale, date) => {
            const month = date.toLocaleString(locale, { month: 'long' });
            const year = date.getFullYear();
            return (
              <div className="react-calendar__navigation__label">
                <span>{month}</span>
                <p>{year}</p>
              </div>
            );
          }}
        />
            </div>
          </Col>
         <Col md={1} style={{padding:'0'}}>
  <div  style={{padding:'0', margin:'0'}}>
    {selectedNotices.length > 0 && (
      <div style={{ background: 'rgb(220, 227, 235)', color:'rgb(3, 54, 94)', border: '1px solid gray', width: '100%', minWidth:'230px', padding: '5px 10px', margin:'0', borderRadius: '20px', marginTop: '140px', marginLeft: '-140px', fontWeight: 'bold' }}>
        {selectedNotices.map((notice, index) => (
          <div key={index} style={{margin:'0'}}>
            <span>- </span> {notice.message}
          </div>
        ))}
      </div>
    )}
  </div>
</Col>
  <Col md={6}>
      <div className="d-flex justify-content-between align-items-center" style={{marginTop: '-4px'}} >
        <Card.Title style={{marginBottom:'10px'}}><b style={{color:'#03365e'}} >{language==="English"?"Notice Board":"सूचना फलक"}   </b></Card.Title>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <select 
            className="form-select form-select-sm" 
            style={{ width: 'auto', marginRight: '10px', marginBottom: '14px', borderRadius: '20px' }}
            value={noticeFilter} 
            onChange={(e) => setNoticeFilter(e.target.value)}
          >
            <option value="all">{language === "English" ? "All Notices" : "सर्व सूचना"}</option>
            <option value="teacher">{language === "English" ? "Teacher Notices" : "शिक्षकांच्या सूचना"}</option>
            {!isAdmin && <option value="student">{language === "English" ? "Student Notices" : "विद्यार्थ्यांच्या सूचना"}</option>}
            <option value="combine">{language === "English" ? "Combine Notices" : "एकत्रित सूचना"}</option>
          </select>
          <Button
            variant="primary"
            className="mb-3 circular-button"
            onClick={() => {
              setNoticeTarget(isAdmin ? 'teacher' : (noticeFilter === 'student' ? 'student' : 'teacher'));
              setShowForm(true);
            }}
          >
            <FaPlusCircle />
          </Button>
        </div>
      </div>

      <div className="scrollable-notices" style={{ maxHeight: '290px', overflowY: 'auto', overflowX: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' , marginTop:'10px'}}>
           <tbody>
            {notices
              .filter(notice => {
                if (isAdmin && notice.type === 'student') return false;
                if (noticeFilter === 'all') return true;
                if (noticeFilter === 'teacher') return notice.type === 'teacher' || notice.type === 'combine';
                if (noticeFilter === 'student') return notice.type === 'student' || notice.type === 'combine';
                if (noticeFilter === 'combine') return notice.type === 'combine';
                return notice.type === noticeFilter;
              })
              .sort((a, b) => (b.createdAt || new Date(b.date).getTime()) - (a.createdAt || new Date(a.date).getTime()))
              .map((notice, index) => (
                <tr style={{ border: '1px solid #ddd' }} key={index}>
                  <td style={{ textAlign: 'left' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h5 style={{ fontSize: '16px', margin: '3px' }}>
                        {index + 1}) {formattedDate(notice.date)}: {notice.title ? <b>{notice.title} - </b> : ""}{notice.message}
                        {notice.type && <span style={{ fontSize: '12px', color: 'gray', marginLeft: '10px' }}>({notice.type.charAt(0).toUpperCase() + notice.type.slice(1)})</span>}
                        {notice.createdByName && <span style={{ fontSize: '12px', color: 'gray' }}> by {notice.createdByName}</span>}
                      </h5>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <a
  href={`https://wa.me/?text=${encodeURIComponent(`🏫 School: **${schoolData?.schoolName}** 🏫\n\nDate: ${formattedDate(notice.date)}\n\n${notice.title ? notice.title + "\n" : ""}- ${notice.message}`)}`}
  target="_blank"
  rel="noopener noreferrer"
  onClick={(e) => {
    e.preventDefault();
    window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(`🏫 School: **${schoolData?.schoolName}** 🏫\n\nDate: ${formattedDate(notice.date)}\n\n${notice.title ? notice.title + "\n" : ""}- ${notice.message}`)}`, '_blank');
  }}
>
  <FaWhatsapp style={{ color: 'green', fontSize: '24px' }} />
</a>
                        <span style={{ width: '10px' }}></span>
                        <Button variant="link" onClick={() => deleteNotice(notice.id || notice.date, notice.subNode)} style={{ padding: 0 }}>
                          <FaTrash style={{ color: 'red' }} />
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
  
      <style jsx>{`
        .scrollable-notices::-webkit-scrollbar {
          display: none; /* Hide scrollbar */
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .scrollable-notices {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
        .circular-button {
          right: 20px;  
          width: 35px;       /* Button width */
          height: 35px;      /* Button height */
          border-radius: 50%; /* Make the button circular */
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;    /* Icon size */
          padding: 0;         /* Remove padding */
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);  /* Optional: Add shadow */
        }

        .circular-button:hover {
          background-color: #0056b3; /* Darker shade on hover */
        }
      `}</style>
  </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>
</Row>
       {/* Modal Form to Add Notice */}
       <Modal show={showForm} onHide={() => setShowForm(false)} centered style={{borderRadius:'8px'}}>
  <Modal.Header closeButton style={{ backgroundColor: '#4CAF50', color: 'white' , borderRadius:'10px 10px 0 0'}}>
    <Modal.Title>{language === "english" ? "Add Notice" : "सूचना जोडा"}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ backgroundColor: '#f0f8ff', borderRadius:' 0 0 10px 10px' }}>
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formDate">
        <Form.Label style={{ color: '#4CAF50', fontWeight: 'bold' }}>
          {language === "english" ? "Select Date" : "तारीख निवडा"}
        </Form.Label>
        <Form.Control
          type="date"
          value={selectedDate ? selectedDate.toISOString().split('T')[0] : ''}
          onChange={(e) => setSelectedDate(new Date(e.target.value))}
          style={{ borderColor: '#4CAF50', borderRadius: '5px' }}
        />
      </Form.Group>
      <Form.Group controlId="formTarget" className="mt-3">
        <Form.Label style={{ color: '#4CAF50', fontWeight: 'bold' }}>
          {language === "english" ? "Notice Type" : "सूचनेचा प्रकार"}
        </Form.Label>
        <Form.Control
          as="select"
          value={noticeTarget}
          onChange={(e) => setNoticeTarget(e.target.value)}
          style={{ borderColor: '#4CAF50', borderRadius: '5px' }}
        >
          <option value="teacher">{language === "english" ? "Teacher Notice" : "शिक्षकांची सूचना"}</option>
          {!isAdmin && <option value="student">{language === "english" ? "Student Notice" : "विद्यार्थ्यांची सूचना"}</option>}
          <option value="combine">{language === "english" ? "Combine Notice" : "एकत्रित सूचना"}</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="formTitle" className="mt-3">
        <Form.Label style={{ color: '#4CAF50', fontWeight: 'bold' }}>
          {language === "english" ? "Title" : "शीर्षक"}
        </Form.Label>
        <Form.Control
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ borderColor: '#4CAF50', borderRadius: '5px' }}
        />
      </Form.Group>
      <Form.Group controlId="formMessage" className="mt-3">
        <Form.Label style={{ color: '#4CAF50', fontWeight: 'bold' }}>
          {language === "english" ? "Notice" : "सूचना"}
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ borderColor: '#4CAF50', borderRadius: '5px' }}
        />
      </Form.Group>
      <Button 
        variant="primary" 
        type="submit" 
        className="mt-3"
        style={{ backgroundColor: '#4CAF50', borderColor: '#4CAF50', borderRadius: '5px', fontWeight: 'bold' }}
      >
        {language === "english" ? "Save" : "सेव करा"}
      </Button>
    </Form>
  </Modal.Body>
</Modal>
    </Container>
<style jsx>{`

.modal-content{
border-radius:10px;
}
`}</style>
    </motion.div>
  );
};

export default SchoolDataCard;
